var exports = {
  "k": "x0a7806d5--2a4995--container",
};

module.exports = exports;
